import {all, call, put, takeLatest} from "redux-saga/effects";
import queryString from "query-string";
import {normalize, schema} from "normalizr";
import {getErrorMessage} from "utils/sagasErrorHandler";
import {
    getSiteGroups,
    getSiteGroupsError,
    getSiteGroupsSuccess,
    editSiteGroup,
    deleteSiteGroup,
    createSiteGroup,
    setSiteGroupFormDialog,
} from "modules/ConfigManager/services/SiteGroup/actions";
import {
    getSiteGroupsRequest,
    createSiteGroupRequest,
    editSiteGroupRequest,
    deleteSiteGroupRequest, getBranchesRequest,
} from "modules/ConfigManager/services/SiteGroup/api";
import {toast} from "react-toastify";
import {updatePartiallyBranchRequest} from "modules/Branches/services/Branches/api";

const siteGroupsSchema = new schema.Entity("site_groups", {}, {idAttribute: "code"});
const siteGroupsListSchema = new schema.Array(siteGroupsSchema);

//Workers
function* handleRefreshList() {
    const {search} = window.location;
    yield put(getSiteGroups(queryString.parse(search)));
}

function* handleGetSiteGroups({payload}) {
    try {
        const {count, site_groups} = yield call(getSiteGroupsRequest, payload);
        const {result, entities} = normalize(site_groups, siteGroupsListSchema);

        const branchesPerSiteGroup = yield all(site_groups.map(({code}) => call(getBranchesRequest, code)));

        const normalizedBranchesPerSiteGroup = branchesPerSiteGroup.reduce((acc, obj) => {
            return { ...acc, ...obj };
        }, {});
        if (entities.site_groups) {
            Object.keys(entities.site_groups).forEach(key => {
                let branchCodes = [];
                if (normalizedBranchesPerSiteGroup[key]) {
                    normalizedBranchesPerSiteGroup[key].forEach(branch => {
                        branchCodes.push(branch.code);
                    })
                }
                entities.site_groups[key].branch_codes = branchCodes;
            });
        }
        yield put(getSiteGroupsSuccess({
            siteGroups: entities.site_groups,
            codes: result,
            count
        }));

    } catch (error) {
        yield put(getSiteGroupsError());
        getErrorMessage(error);
    }
}

function* handleCreateSiteGroup ({ payload }) {
    try {
        const { branch_codes, ...rest } = payload;
        const siteGroupCode = payload.code;
        yield call(createSiteGroupRequest, rest);
        yield all(branch_codes.map((code) => call(updatePartiallyBranchRequest, { code, "site_group_code": siteGroupCode })));
        yield put(setSiteGroupFormDialog());
        yield call(toast.success, "The site group has been successfully created");

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleEditSiteGroup({payload}) {
    try {
        const { branch_codes, attached_branch_codes, detached_branch_codes, ...rest } = payload;
        const siteGroupCode = payload.code;
        yield call(editSiteGroupRequest, rest);
        yield all(attached_branch_codes.map((code) => call(updatePartiallyBranchRequest, { code, "site_group_code": siteGroupCode })));
        yield all(detached_branch_codes.map((code) => call(updatePartiallyBranchRequest, { code, "site_group_code": "UNKNOWN" })));
        yield put(setSiteGroupFormDialog());
        yield call(toast.success, `The site group with code - ${payload.code} has been successfully edited`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleDeleteSiteGroup({payload}) {
    try {
        yield call(deleteSiteGroupRequest, payload);

        yield put(setSiteGroupFormDialog());
        yield call(toast.success, `The site group with code - ${payload} has been successfully deleted`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* siteGroupsSagas() {
    yield all([
        yield takeLatest(getSiteGroups, handleGetSiteGroups),
        yield takeLatest(createSiteGroup, handleCreateSiteGroup),
        yield takeLatest(editSiteGroup, handleEditSiteGroup),
        yield takeLatest(deleteSiteGroup, handleDeleteSiteGroup),
    ]);
}
